module.exports = __webpack_public_path__ + "img/map_mobile_8.122f775d.png";